import { networkActionsCreator } from '../../../../admincore'

const actions = {
  ...networkActionsCreator('trips'),
}

export default actions

export function load(params) {
  return {
    type: actions.LOAD,
    payload: {
      params,
    },
  }
}
